export const keying_ar_commercial = ( documento_numero: string, denominacion: string ) => {
  return [
    {
      request: {
        session: {
          quoteback: "",
          customerId: "",
          profileId: "dfkl_ar_profile_commercial_exactly_1",
          entityType: "COMMERCIAL",
        },
        entity: {
          consumer: null,
          commercial: {
            names: [
              {
                data: {
                  NAME_MIDDLE_NAME: "",
                  NAME_FIRST_NAME: "",
                  NAME_PREFIX: "",
                  NAME_LAST_NAME: "",
                  NAME_SUFFIX: "",
                  NAME_BUSINESS_NAME: denominacion ,
                },
              },
            ],
            identifiers: {
              IDENTIFIER_BUSINESS_ID: documento_numero,
              IDENTIFIER_ORIGIN_COUNTRY_NUMERIC_CODE: "032",
              IDENTIFIER_ORIGIN_COUNTRY_NAME: "ARGENTINA",
              IDENTIFIER_SSN: "",
              IDENTIFIER_ORIGIN_COUNTRY_CODE: "AR",
              IDENTIFIER_STATEDL: "",
              IDENTIFIER_BUSINESS_ID_TYPE: "16",
            },
            website: {},
            discoveryData: {},
            lineageKey: "",
            legacyIds: {},
            phones: {},
            emails: {},
            owners: {},
            addresses: [],
          },
        },
      },
      response: null,
    },
  ];
};
